import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { GetBlacklistRequest, GetBlacklistResponse } from '../../../type'
import { getBlacklist } from '../../services'
import { BlacklistQueryKeys } from '../../../keys'

export default function useQueryGetBlacklist(
	payload: GetBlacklistRequest,
	props?: UseBaseQueryOptions<GetBlacklistResponse>,
) {
	return useQuery({
		queryKey: [BlacklistQueryKeys.GetBlacklist, payload],
		queryFn: () => getBlacklist(payload),
		...props,
	})
}
